(() => {
  // Money formatter
  const money = (cents) => {
    const cur =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: cur
    }).format((cents || 0) / 100);
  };

  // Fetch product JSON by handle
  async function productByHandle(handle) {
    const r = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!r.ok) throw new Error(`Product not found: ${handle}`);
    return r.json();
  }

  const firstAvailableVariant = (p) =>
    p.variants.find((v) => v.available) || p.variants[0];

  const imageSrc = (p) => {
    const img = (p.images && p.images[0]) || p.featured_image;
    if (!img) return '';
    let src = typeof img === 'string' ? img : img.src;
    if (src && src.startsWith('//')) src = 'https:' + src;
    return src;
  };

  function render(el, product) {
    const variant = firstAvailableVariant(product);
    const url = `/products/${product.handle}${variant ? `?variant=${variant.id}` : ''}`;
    const img = imageSrc(product);
    const compare = variant?.compare_at_price && variant.compare_at_price > variant.price;

    el.innerHTML = `
      <article class="bpw-card">
        <a class="bpw-media" href="${url}">
          ${img ? `<img src="${img}" alt="${product.title}" loading="lazy">` : ''}
        </a>
        <div class="bpw-body">
          <h3 class="bpw-title"><a href="${url}">${product.title}</a></h3>
          <div class="bpw-price">
            <span class="bpw-now">${money(variant?.price)}</span>
            ${compare ? `<s class="bpw-compare">${money(variant.compare_at_price)}</s>` : ''}
          </div>
          <a class="bpw-btn" href="${url}">${el.dataset.cta || 'Zum Produkt'}</a>
        </div>
      </article>
    `;
    el.classList.add('bpw-mounted');
  }

  async function mount(el) {
    const handle = el.dataset.handle;
    if (!handle) {
      el.innerHTML = '<em data-bpw-error>Fehlender data-handle.</em>';
      return;
    }
    try {
      const product = await productByHandle(handle);
      render(el, product);
    } catch (e) {
      console.error('Widget error:', e);
      el.innerHTML = '<em data-bpw-error>Produkt nicht gefunden.</em>';
    }
  }

  function mountAll(root = document) {
    root.querySelectorAll('[data-product-widget]:not(.bpw-mounted)').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }
})();
